<div
	class="full-width m-b-1"
	*ngIf="
		accountSettings.PROJECT_GROUPS_ENABLED && (projectDetailsStore.projectGroups$ | async)?.length
	"
>
	<div
		*ngFor="let projectGroup of projectDetailsStore.projectGroups$ | async; let i = index"
		[ngClass]="{ 'm-t-1': i != 0 }"
	>
		<mat-card
			class="cursor-pointer project_group_container"
			(click)="onProjectGroupCardClick(projectGroup, $event)"
			[ngClass]="{
				'panel-selected mat-elevation-z4 selected_group_container':
					selectedProjectGroupIds.indexOf(projectGroup.id) > -1
			}"
		>
			<mat-card-content>
				<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
					<div fxFlex class="font-size-16 font-weight-bold">
						{{ projectGroup.name }}
					</div>
					<div fxFlex class="font-size-14">{{ projectGroup.numberOfCarriers }} Carriers</div>
					<div fxFlex class="font-size-14">
						Rates:
						<span
							*ngIf="projectGroup.minimumRate && projectGroup.maximumRate; else rateNA"
							class="font-size-14"
						>
							{{ TO_DOLLARS(projectGroup.minimumRate) | currency : 'USD' : 'symbol' : '1.0-0' }} -
							{{ TO_DOLLARS(projectGroup.maximumRate) | currency : 'USD' : 'symbol' : '1.0-0' }}
						</span>
					</div>
					<div fxFlex="10" class="font-size-14">Trucks: {{ projectGroup.trucksCount }}</div>
					<div fxFlex="10" class="font-size-14">Lanes: {{ projectGroup.lanesCount }}</div>
					<div fxFlex class="font-size-14">
						Contact:
						{{
							DELAY_CONTACT_LABELS[projectGroup.delayByMinutes]
								? DELAY_CONTACT_LABELS[projectGroup.delayByMinutes]
								: projectGroup.delayByMinutes + ' minutes later'
						}}
					</div>
					<div fxFlex="5" fxLayoutAlign="end center">
						<mat-icon
							class="primary-light-color cursor-pointer"
							matTooltipClass="custom-tooltip-width"
							*ngIf="projectGroup.id !== selectedProjectGroupId"
						>
							expand_more
						</mat-icon>
						<mat-icon
							*ngIf="projectGroup.id === selectedProjectGroupId"
							class="primary-light-color cursor-pointer"
							matTooltipClass="custom-tooltip-width"
						>
							expand_less
						</mat-icon>
					</div>
				</div>
			</mat-card-content>
		</mat-card>

		<div class="m-t-0-5" *ngIf="projectGroup.id === selectedProjectGroupId"></div>

		<app-procured-carriers
			#groupCarriersComponent
			*ngIf="projectGroup.id === selectedProjectGroupId"
			[isLoadingProjectsList]="false"
			[projectCarrierMapList]="projectGroup.projectCarrierMapsList"
			[totalNumberOfProjects]="projectGroup.projectCarrierMapsList?.length"
			[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIds"
			[usersList]="projectDetailsStore.usersList$ | async"
			[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
			[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
			[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
			(panelClicked)="onProcuredCarrierClick($event?.projectCarrierMap, $event?.event)"
			(openFullProfileEvent)="openFullProfileEvent.emit($event)"
		></app-procured-carriers>
	</div>
</div>

<ng-template #rateNA> N/A </ng-template>
